import React, { useContext, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase-config";
import Layout from "../layout/Layout";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import EditExchangeForm from "./form";
import { DynamicTableCell, useTableContext } from "../../contexts/TableContext";
import Tippy from "@tippyjs/react";
import { MdAdd, MdModeEditOutline } from "react-icons/md";
import {
  addExchange,
  fetchExchange,
  updateAmount,
} from "../../services/exchange";
import BeatLoader from "react-spinners/BeatLoader";
import TablePagination from "@mui/material/TablePagination";
import { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import Constant from "../../Constant";
import "./index.scss";
import ExchangeCreationForm from "./createExchangeForm";
import { MyContext } from "../../contexts/ContextProvider";
import { getCurrencies } from "../../services/currencies";

const columns = [
  {
    id: "1",
    label: "Exchange Type",
    minWidth: 100,
  },
  {
    id: "2",
    label: "Exchange Amount",
    minWidth: 100,
  },
  {
    id: "3",
    label: "Exchange Emit Currency",
    minWidth: 100,
  },
  {
    id: "4",
    label: "Updated At",
    minWidth: 100,
  },
  {
    id: "5",
    label: "Action",
    minWidth: 100,
  },
];

const override = {
  textAlign: "center",
  marginTop: "20px",
};

function Rates() {
  const [user] = useAuthState(auth);
  const [exchange, setExchange] = useState([]);
  const [authToken, setAuthToken] = useState("");
  const [page, setPage] = React.useState(0);
  const [refresh, setRefresh] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [showForm, setShowForm] = React.useState(false);
  const modalViewRef = React.useRef(null);
  const editExchangeRef = React.useRef(null);
  const [currentRate, setCurrentRate] = React.useState(null);

  const handleChangePage = (event, newPage) => {
    //TODO Get new page from API
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const { loading, setLoading } = useTableContext();

  const closeDetailsModal = () => {
    modalViewRef.current.close();
    editExchangeRef.current.clearVals();
    console.log("closing form ...");
  };

  const getRates = (token) => {
    setLoading(true);
    fetchExchange(token)
      .then((res) => {
        if (res.status_code == 200) {
          setExchange(res.data);
        } else {
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        console.log("ERROR: ", err);
        toast.error(`${err}`);
      })
      .finally(() => {
        const timeID = setTimeout(() => {
          setLoading(false);
        }, 3000);
      });
  };

  const updateTransaction = async () => {
    const update = editExchangeRef.current.getValues();
    if (!update) return closeDetailsModal();
    setLoading(true);
    updateAmount(currentRate.id, update, authToken)
      .then((result) => {
        if (result.status_code === 200) {
          toast(`${result.message}`);
          setRefresh((prev) => !prev);
        } else {
          toast.error(`${result.message}`);
        }
      })
      .catch((err) => {
        toast(`Sorry, we could not update this rate. Please try again`);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    closeDetailsModal();
  };

  const handleFormSubmit = (values) => {
    // setLoading(true);
    addExchange(values, authToken)
      .then((res) => {
        setRefresh((prev) => !prev);
        setShowForm((prev) => !prev);
        toast(`${res.message}`);
      })
      .catch((err) => {
        toast.error(`${err.message}`);
      })
      .finally(() => {
        setRefresh((prev) => !prev);
      });
  };

  const closeCreateForm = () => {
    setShowForm((prev) => !prev);
  };

  useEffect(() => {
    user.getIdToken(true).then((token) => {
      // console.log(`Auth Token ${token}`);
      setAuthToken(token);
      getRates(token);
    });
  }, [refresh]);
  return (
    <Layout>
      <div className="m-2 md:m-10 mt-24 p-2 md:p-5 bg-white rounded-3xl">
        <div className="creation_sec">
          <button
            className="creartbtn"
            type="button"
            onClick={() => setShowForm((prev) => !prev)}
          >
            Create Rate
            <MdAdd className="text-2xl" />
          </button>
        </div>
        <Paper className="main" sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            sx={{ maxHeight: 500, minWidth: 600 }}
            style={{ boxShadow: "none" }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="center"
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {exchange
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        <DynamicTableCell>
                          <TableCell align="center">
                            {row.exchange_type}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">
                            {row.exchange_amount}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">
                            {row.exchange_emit_currency}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">
                            {new Date(row.updated_at).toDateString()},{" "}
                            {new Date(row.updated_at).toLocaleTimeString()}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">
                            <Tippy content="Edit" animation="fade">
                              <button
                                onClick={() => {
                                  setCurrentRate(row);
                                  modalViewRef.current.open();
                                }}
                                className="bg-[#00A5EE] rounded-full text-[#000] p-2"
                              >
                                <MdModeEditOutline size={16} color="#fff" />
                              </button>
                            </Tippy>
                          </TableCell>
                        </DynamicTableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <BeatLoader
            color="#36d7b7"
            loading={loading}
            cssOverride={override}
          />
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={exchange.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <Modal
          title={`Update Amount of - ${
            currentRate ? currentRate.exchange_emit_currency : ""
          }`}
          onSubmit={() => updateTransaction()}
          onClose={() => console.log("Closing form...")}
          ref={modalViewRef}
        >
          <EditExchangeForm
            ref={editExchangeRef}
            data={exchange}
          />
          <BeatLoader
            color={Constant.spinner_color}
            loading={loading}
            className="__center_spinner"
            cssOverride={{
              textAlign: "center",
              marginTop: "20px",
            }}
          />
        </Modal>
        {showForm && (
          <div className="create_sec">
            <ExchangeCreationForm
              submitForm={handleFormSubmit}
              closeForm={closeCreateForm}            />
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Rates;
